// extracted by mini-css-extract-plugin
module.exports = {"container":"login_container__3f4Dd","tab":"login_tab__6X2QU"};